import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { MiniQuestionnaireData } from "@/types/miniQuestionnaire";

interface MiniSection6Props {
  data: MiniQuestionnaireData;
  updateData: (field: keyof MiniQuestionnaireData, value: string) => void;
}

const MiniSection6 = ({ data, updateData }: MiniSection6Props) => {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-semibold text-feel-foreground mb-6">
        Section IX – Sommeil
      </h2>

      {/* Question 11 - Heures de sommeil */}
      <div className="space-y-3">
        <Label className="text-lg font-medium text-feel-foreground">
          Q11. Combien d'heures dormez‑vous habituellement par nuit ?
        </Label>
        <RadioGroup
          value={data.heures_sommeil}
          onValueChange={(value) => updateData("heures_sommeil", value)}
          className="space-y-2"
        >
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="moins_6h" id="sommeil-moins6" />
            <Label htmlFor="sommeil-moins6" className="cursor-pointer">Moins de 6 heures</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="6_8h" id="sommeil-6-8" />
            <Label htmlFor="sommeil-6-8" className="cursor-pointer">Entre 6 et 8 heures</Label>
          </div>
          <div className="flex items-center space-x-3">
            <RadioGroupItem value="plus_8h" id="sommeil-plus8" />
            <Label htmlFor="sommeil-plus8" className="cursor-pointer">Plus de 8 heures</Label>
          </div>
        </RadioGroup>
      </div>
    </div>
  );
};

export default MiniSection6;
